import WarningIcon from "@mui/icons-material/Warning";
import { Box } from "@mui/material";
import Flex from "../../../../../../../components/Flex";
import Text from "../../../../../../../components/Text";
import ConfirmationModal from "../../../../../../../components/app/ConfirmationModal";
import { DisclosureHost } from "../../../../../../../hooks/use-disclosure";

interface VisitNoteConfirmationModalProps {
  disclosureHost: DisclosureHost;
  onConfirm: () => void;
}

const VisitNoteConfirmationModal = ({
  disclosureHost,
  onConfirm,
}: VisitNoteConfirmationModalProps) => {
  return (
    <ConfirmationModal
      centerButtons={true}
      onConfirm={onConfirm}
      disclosureHost={disclosureHost}
      confirmationText="Yes, Leave"
      cancelText="Stay"
      maxWidth={"sm"}
      title={
        <Flex flexDirection="column" alignItems="center" gap={2}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "60px",
              height: "60px",
              borderRadius: "50%",
              backgroundColor: "#FFE6E6",
              mb: 1,
            }}
          >
            <WarningIcon
              sx={{
                color: "#D32F2F",
                fontSize: "32px",
              }}
            />
          </Box>
          <Text fontWeight={"medium"} fontSize={"24px"} textAlign="center">
            Are You Sure ?
          </Text>
          <Text fontSize={"16px"} color="#666666" textAlign="center">
            You want to End This Encounter?
          </Text>
        </Flex>
      }
    />
  );
};

export default VisitNoteConfirmationModal;
